export class Utils {
	static prepareStylesArray(arr) {
		return (arr || []).map(o => ({key: o.id, name: o.title, type: o.label.replace('label-', '')}));
	}

	static generateUniqueId() {
        return Math.floor(Math.random() * 0xFFFF).toString();
    }

    /*
    * For preparing class names
    * https://www.npmjs.com/package/classnames
    */ 

    static classNames() {
    	var hasOwn = {}.hasOwnProperty;

    	return (() => {
    		var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(Utils.classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
    	})();
    }

    static prepareNameClass(prefix, name) {
    	if (name === undefined) return '';
    	return `${prefix}-${name}`.replace(' ', '-').replace('.', '-').toLowerCase();
    }
};

export default Utils;
